import React from "react";
export default function Simple() {
  return (
    <div>
      <p>Es llamada simple a beeper la que no requiere atención en persona </p>
    </div>
  )
}